import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import elements from "@fae/source/data/elements.js"
import keywords from "@fae/source/data/games/ember/keywords.js"

import Unit from "@fae/source/models/Unit.js"

export function ShortPower({children}) {
    const DIVISOR = 10
    if(children == "" || children == 0) {
        return
    } else {
        return (parseInt(children) / DIVISOR) || children || ""
    }
}

export function Power({children}) {
    const DIVISOR = 10 // App?.game?.chapter?.stage?.configuration?.isNotDividedByTen ? 1 : 10
    if(children == "" || children == 0) {
        return
    } else {
        let number = (parseInt(children) / DIVISOR) || children || ""
        if(number == 0.5) number = "½"
        return number
    }
}

export function Powerboost({children}) {
    const SIGNS = {"-1": "-", "1": "+"}
    const DIVISOR = 10 // App?.game?.chapter?.stage?.configuration?.isNotDividedByTen ? 1 : 10
    if(children == undefined
    || children == "") {
        return
    } else if(children == 0){
        return "+0"
    } else {
        return SIGNS[Math.sign(children)] + ((parseInt(children) / DIVISOR) || children || "")
    }
}

export function Keyword() {
    const keywordKey = this.props.children.toLowerCase()
    const keyword = keywords[keywordKey]
    return (
        <span class="Keyword" link={keyword != undefined}>
            {this.props.children}
        </span>
    )
}

// expecting the children to be the elementKey!!
export function Element({children}) {
    if(children == "" || children == 0) {
        return
    } else {
        return <span class="Keyword" link={true} element={children.toLowerCase()}>{children}</span>
    }
}

export function BasicDescription({stage, unit, item}) {
    if(item.attackrange == 1) {
        return <span>Attack for <Power>{item.power}</Power> <Element>{capitalize(item.element)}</Element> Damage.</span>
    } else {
        return <span>Attack for <Power>{item.power}</Power> <Element>{capitalize(item.element)}</Element> Damage<br/>at long range, from 2 tiles away.</span>
    }
}

function capitalize(string) {
    return string[0].toUpperCase() + string.slice(1)
}
